<template>
	<db-row class="picker-wrapper">
		<db-row class="auto-fill ovh" valign="middle" align="center">
			<db-icon icon="loading" class="animation-circle" size="48" v-if="!loading" />
			<van-picker ref="picker" v-else :columns="pickerColumns" @change="changeHandler" />
		</db-row>
		<db-col height="100" class="picker-btn" align="center">
			<db-button type="primary" around width="90%" @click="chose">确定选择</db-button>
		</db-col>
	</db-row>
</template>

<script>
	import Vue from 'vue'
	import {Picker} from 'vant'
	import 'vant/lib/index.css'
	import {Picker as PickerModel} from '../../../../model/Dialog'
	import PickerValue from '../../../../model/PickerValue'
	import Code from '../../../../model/Code'
	
	Vue.use(Picker)
	
	/**
	 * 1、传给picker的值只能是字符串或者数值，picker内部将自动转成字符串数组
	 */
	export default {
		name: 'picker_',
		
		props: {
			columns: {
				type: [Array, Function, Promise],
				default(){
					return []
				}
			},
			
			value: {
				type: [String, Number, Boolean, Array, Object],
				default: ''
			}
		},
		
		data(){
			return {
				loading: false,
				tmpColumns: []
			}
		},
		
		async created(){
			if(typeof this.columns === 'function'){
				this.tmpColumns = await this.columns()
				this.loading = true
				this.$emit('ready')
			}else{
				this.tmpColumns = this.columns
				this.loading = true
			}
		},
		
		computed: {
			pickerValues(){
				return Array.isArray(this.value) ? this.value : String(this.value).split(',')
			},
			
			pickerColumns(){
				return this.tmpColumns.map((column, idx) => {
					const {values, defaultIndex} = new PickerValue({
						values: column
					}, this.pickerValues[idx])
					return {
						values,
						defaultIndex
					}
				})
			}
		},
		
		methods: {
			chose(){
				this.$emit('close')
				const codes = this.$refs.picker.getValues().map(val => {
					if(typeof val === 'object'){
						return val.code
					}
					return val
				}).join(',')
				const texts = this.$refs.picker.getValues().map(val => {
					if(typeof val === 'object'){
						return val.text
					}
					return val
				}).join(',')
				
				this.$emit('input', {
					codes,
					texts
				})
			},
			
			changeHandler(picker, values, idx){
				this.$emit('change', picker, values, idx)
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.picker-wrapper{
		padding: 10px;
		
		.picker-btn{
			padding: 0 20px;
		}
		
		.van-picker-column__item{
			font-size: 32px;
			color: #333;
			text-align: center;
		}
		
		.van-ellipsis{
			width: auto;
			display: inline-block;
			text-align: center;
		}
		
		.van-picker-column__item--selected{
			font-size: 32px;
			color: $btn_primary_color;
			//font-weight: bold;
			
			.van-ellipsis{
				width: auto;
				display: inline-block;
				text-align: center;
				//background: $btn_success_color;
				//padding: 8px 12px;
				color: $btn_success_color;
				font-weight: bold;
			}
		}
		
		.van-picker__frame{
			left: 0;
		}
		
		[class*=van-hairline]::after{
			background: rgba(#000, .05);
			border-radius: 100px;
		}
		
		/* [class*=van-hairline]::before{
			content: '';
			position: absolute;
			top: 50%;
			left: 20px;
			width: 0;
			height: 0;
			border: solid 10px transparent;
			border-left-color: #999;
			margin-top: -10px;
			z-index: 3;
		} */
	}
</style>
